// Types for Branon+ (Grade 11-12 / JEE-NEET)

export interface Flashcard {
  front: string;
  back: string;
}

export type QuestionLevel = 'Basic' | 'Standard' | 'Advanced';

export interface TestQuestion {
  id: string;
  question: string;
  options: string[];
  correctOptionIndex: number;
  conceptTag?: string;
  difficultyScore?: number;
}

export interface Test {
  id: string;
  difficulty: string;
  description?: string;
  questions: TestQuestion[];
}

export interface ConceptPlus1 {
  id: number;
  name: string;
  subject_id: number | null;
  subject_name?: string;
  concept_type: string | null;
  grade_range: number[] | null;
  explanation_basic: string | null;
  explanation_standard: string | null;
  explanation_advanced: string | null;
  formula_summary: string | null;
  common_mistakes: string | null;
  tips_and_tricks: string | null;
  real_life_example: string | null;
  flashcard_count?: number;
  flashcards?: Flashcard[];
  pyq_count?: number;
}

export interface PYQReference {
  id: number;
  exam: string;
  year: number;
  paper: string | null;
  question_number: number;
  difficulty_level: number | null;
  concept_id?: number;
  concept_name?: string;
}

export interface StudentSession {
  student_id: string;
  student_code: string;
  grade_level: number;
  school_id: number;
  expires_at: string;
  section_id?: number;
  section_name?: string;
  planType?: 'core' | 'premium';
  board?: string; // School board (CBSE, ICSE, State Board, IB, Cambridge)
  state_board?: string; // Specific state (e.g. Maharashtra) for State Board exam differentiation — preview only, server re-derives authoritatively
}

export interface LoadingState {
  isLoading: boolean;
  error: string | null;
}

// Subject mapping for Plus1
export const PLUS1_SUBJECTS: Record<number, string> = {
  1: 'Physics',
  2: 'Chemistry',
  3: 'Mathematics',
  4: 'Biology',
};

// Exam types (dynamic - driven by regionConfig.curriculum.availableExams)
export type ExamType = string;

// Exam Prep Types
export interface ExamPrepModule {
  module_id: number;
  subject: string;
  chapter: string;
  module_type: string;
  title: string;
  description: string | null;
  order_index: number;
}

export interface ExamPrepContent {
  content_id: number;
  module_id: number;
  content_type: string;
  content_body: Record<string, unknown>;
  order_index: number;
}

export interface ExamPrepSolvedExample {
  example_id: number;
  module_id: number;
  example_title: string;
  final_answer: string;
  step_by_step_solution: string[];
  concept_logic: string;
  pattern_notes: string | null;
  common_mistakes: string[] | null;
}
